import { render, staticRenderFns } from "./myEntrepreneurship.vue?vue&type=template&id=79fe324a&scoped=true"
import script from "./myEntrepreneurship.vue?vue&type=script&lang=js"
export * from "./myEntrepreneurship.vue?vue&type=script&lang=js"
import style0 from "./myEntrepreneurship.vue?vue&type=style&index=0&id=79fe324a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fe324a",
  null
  
)

export default component.exports